import { render, staticRenderFns } from "./DarkPatternDescriptionComponent.vue?vue&type=template&id=f9c6eac2&"
import script from "./DarkPatternDescriptionComponent.vue?vue&type=script&lang=js&"
export * from "./DarkPatternDescriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./DarkPatternDescriptionComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports